import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, combineLatest, Observable, of } from "rxjs";
import { catchError, tap } from 'rxjs/operators';
import { BaseService } from '../base.service';
import { NotificationService } from '../util/notification.service';
import { Role } from './models/role.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends BaseService {

  rolesInformations$ = new BehaviorSubject<Role[]>([]);

  constructor(private httpClient: HttpClient, protected notificationService: NotificationService, protected translate: TranslateService) {
    super(notificationService, translate);
  }

  getRolesConfiguration(): Observable<Role[]> {
    const calls: Observable<Role>[] = [];

    // remove duplicates entry
    for (let role of [...new Set(environment.roles)]) {
      calls.push(this.getRoleObject(role));
    }

    if (calls.length > 0) {
      return combineLatest(calls).pipe(
        tap(roles => this.rolesInformations$.next(roles.filter(r => r)))
      );
    }
  }

  getRoleObject(roleName: string): Observable<Role> {
    return this.httpClient.get<Role>(`${environment.api.mobilityUrl}/api/user-manager/v1/roles/${roleName}`).pipe(
      catchError(err => {
        if (err.status === 404) {
          console.error(err);
          console.error(`Role with name ${roleName} doesn't exists`);
        }
        return of(null);
      })
    );
  }

  compareDomainAndRankBetweenRoles(roleAgentConnected: Role, roleAgent: Role): boolean {
    if (roleAgentConnected && roleAgent) {
      if (roleAgentConnected.domain === 'GLOBAL') {
        if (roleAgent.domain === 'GLOBAL') {
          return roleAgentConnected.rank >= roleAgent.rank;
        }
        return true;
      }

      if (roleAgentConnected.domain === roleAgent.domain) {
        return roleAgentConnected.rank >= roleAgent.rank;
      }
    }
    return false;
  }

  getRoleListUsableByAgent(roleAgent: Role) {
    const roles = [...this.rolesInformations$.getValue()];
    if (roleAgent.domain === 'GLOBAL') {
      return roles.filter(r => (r.domain === 'GLOBAL' && roleAgent.rank >= r.rank) || r.domain !== 'GLOBAL').map(r => r.name);
    }
    return roles.filter(r => roleAgent.domain === r.domain && roleAgent.rank >= r.rank).map(r => r.name);
  }
}
